export { default } from './ChangePasswordForm';
